import { CommonModule } from '@angular/common';
import { ScrollPanel as ScrollPanelBase } from 'prime-ng-old/scrollpanel';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
const _c0 = ["*"];
function UiScrollPanelComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
export let UiScrollPanelComponent = /*#__PURE__*/(() => {
  class UiScrollPanelComponent extends ScrollPanelBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiScrollPanelComponent_BaseFactory;
        return function UiScrollPanelComponent_Factory(__ngFactoryType__) {
          return (ɵUiScrollPanelComponent_BaseFactory || (ɵUiScrollPanelComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiScrollPanelComponent)))(__ngFactoryType__ || UiScrollPanelComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiScrollPanelComponent,
        selectors: [["ui-scrollPanel"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c0,
        decls: 11,
        vars: 16,
        consts: [["container", ""], ["content", ""], ["xBar", ""], ["yBar", ""], [3, "ngClass", "ngStyle"], [1, "p-scrollpanel-wrapper"], [1, "p-scrollpanel-content", 3, "mouseenter", "scroll"], [4, "ngTemplateOutlet"], ["tabindex", "0", "role", "scrollbar", 1, "p-scrollpanel-bar", "p-scrollpanel-bar-x", 3, "mousedown", "keydown", "keyup", "focus", "blur"], ["tabindex", "0", "role", "scrollbar", 1, "p-scrollpanel-bar", "p-scrollpanel-bar-y", 3, "mousedown", "keydown", "keyup", "focus"]],
        template: function UiScrollPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 4, 0)(2, "div", 5)(3, "div", 6, 1);
            i0.ɵɵlistener("mouseenter", function UiScrollPanelComponent_Template_div_mouseenter_3_listener() {
              return ctx.moveBar();
            })("scroll", function UiScrollPanelComponent_Template_div_scroll_3_listener($event) {
              return ctx.onScroll($event);
            });
            i0.ɵɵprojection(5);
            i0.ɵɵtemplate(6, UiScrollPanelComponent_ng_container_6_Template, 1, 0, "ng-container", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 8, 2);
            i0.ɵɵlistener("mousedown", function UiScrollPanelComponent_Template_div_mousedown_7_listener($event) {
              return ctx.onXBarMouseDown($event);
            })("keydown", function UiScrollPanelComponent_Template_div_keydown_7_listener($event) {
              return ctx.onKeyDown($event);
            })("keyup", function UiScrollPanelComponent_Template_div_keyup_7_listener() {
              return ctx.onKeyUp();
            })("focus", function UiScrollPanelComponent_Template_div_focus_7_listener($event) {
              return ctx.onFocus($event);
            })("blur", function UiScrollPanelComponent_Template_div_blur_7_listener() {
              return ctx.onBlur();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 9, 3);
            i0.ɵɵlistener("mousedown", function UiScrollPanelComponent_Template_div_mousedown_9_listener($event) {
              return ctx.onYBarMouseDown($event);
            })("keydown", function UiScrollPanelComponent_Template_div_keydown_9_listener($event) {
              return ctx.onKeyDown($event);
            })("keyup", function UiScrollPanelComponent_Template_div_keyup_9_listener() {
              return ctx.onKeyUp();
            })("focus", function UiScrollPanelComponent_Template_div_focus_9_listener($event) {
              return ctx.onFocus($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.styleClass);
            i0.ɵɵproperty("ngClass", "p-scrollpanel p-component")("ngStyle", ctx.style);
            i0.ɵɵattribute("data-pc-name", "scrollpanel");
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("data-pc-section", "wrapper");
            i0.ɵɵadvance();
            i0.ɵɵattribute("data-pc-section", "content");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
            i0.ɵɵadvance();
            i0.ɵɵattribute("aria-orientation", "horizontal")("aria-valuenow", ctx.lastScrollLeft)("data-pc-section", "barx")("aria-controls", ctx.contentId);
            i0.ɵɵadvance(2);
            i0.ɵɵattribute("aria-orientation", "vertical")("aria-valuenow", ctx.lastScrollTop)("data-pc-section", "bary")("aria-controls", ctx.contentId);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle],
        styles: ["@layer primeng{.p-scrollpanel-wrapper[_ngcontent-%COMP%]{overflow:hidden;width:100%;height:100%;position:relative;float:left}.p-scrollpanel-content[_ngcontent-%COMP%]{height:calc(100% + 18px);width:calc(100% + 18px);padding:0 18px 18px 0;position:relative;overflow:auto;box-sizing:border-box}.p-scrollpanel-bar[_ngcontent-%COMP%]{position:relative;background:#c1c1c1;border-radius:3px;cursor:pointer;opacity:0;transition:opacity .25s linear}.p-scrollpanel-bar-y[_ngcontent-%COMP%]{width:9px;top:0}.p-scrollpanel-bar-x[_ngcontent-%COMP%]{height:9px;bottom:0}.p-scrollpanel-hidden[_ngcontent-%COMP%]{visibility:hidden}.p-scrollpanel[_ngcontent-%COMP%]:hover   .p-scrollpanel-bar[_ngcontent-%COMP%], .p-scrollpanel[_ngcontent-%COMP%]:active   .p-scrollpanel-bar[_ngcontent-%COMP%]{opacity:1}.p-scrollpanel-grabbed[_ngcontent-%COMP%]{-webkit-user-select:none;user-select:none}}"],
        changeDetection: 0
      });
    }
  }
  return UiScrollPanelComponent;
})();